// @flow
import React, { useEffect } from 'react';
import Routes from './routes/Routes';

import config from './config';

// setup fake backend
import { configureFakeBackend } from './helpers';

// Themes
import './assets/scss/Saas.scss';

// configure fake backend
// configureFakeBackend();

const brand = config.RDPMS_APP_BRAND;

/**
 * Main app component
 */
const App = () => {
    useEffect(() => {
        document.title = brand === 'railview' ? 'RailView' : 'CELView';

        const favicon = brand === 'railview' ? '/branding/railview/favicon.ico' : '/branding/celview/favicon.ico';

        // remove all old favicons
        const oldLinks = document.querySelectorAll("link[rel*='icon']");

        oldLinks.forEach((item) => item.remove());

        // create fresh favicon
        const link = document.createElement('link');

        link.rel = 'icon';
        link.type = 'image/x-icon';
        link.href = favicon;

        document.head.appendChild(link);
    }, []);

    return <Routes />;
};

export default App;
